export const toCompoundKey = (wordPackageId: string, wordId: string) =>
	`${wordPackageId}//${wordId}`;

export const parseCompoundKey = (compoundKey: string) => {
	return {
		wordPackageId: compoundKey.split("//")[0],
		wordId: compoundKey.split("//")[1],
	};
};
